import { NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, LayoutDashboard, Users, Calendar, Crown, Sparkles, Receipt, Megaphone, Settings } from "lucide-react";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/clientes", label: "Clientes", icon: Users },
  { to: "/agenda", label: "Agenda", icon: Calendar },
  { to: "/membresias", label: "Membresías", icon: Crown },
  { to: "/servicios", label: "Servicios", icon: Sparkles },
  { to: "/ventas", label: "Ventas", icon: Receipt },
  { to: "/marketing", label: "Marketing", icon: Megaphone },
  { to: "/ajustes", label: "Ajustes", icon: Settings },
];

export default function MobileNav() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="lg:hidden sticky top-0 z-40 flex items-center justify-between px-5 py-3 border-b" style={{ backgroundColor: "#1A1A1A", color: "#FBF6F2", borderColor: "#2a2a2a" }}>
        <div className="flex items-center gap-3">
          <div className="rounded px-3 py-1.5" style={{ backgroundColor: "#FBF6F2" }}>
            <img
              src="https://customer-assets.emergentagent.com/job_salon-studio-pro-2/artifacts/7kyv63p4_LOGO%20LAKA%20CLUB%20BEAUTY.webp"
              alt="LAKA Club Beauty"
              className="h-8 w-auto object-contain"
              data-testid="mobile-logo"
            />
          </div>
          <div className="text-[9px] tracking-[0.3em] uppercase" style={{ color: "#D6B36A" }}>
            Business Studio
          </div>
        </div>
        <button
          data-testid="mobile-nav-toggle"
          onClick={() => setOpen(!open)}
          className="p-2 rounded-md border border-[#333]"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden fixed inset-0 top-[64px] z-30" style={{ backgroundColor: "#1A1A1A" }}>
          <nav className="px-4 py-6 space-y-1">
            {NAV.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-md text-sm ${
                    isActive ? "bg-[#242424] text-[#FBF6F2]" : "text-[#B8B0A6]"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon size={18} strokeWidth={1.25} style={{ color: isActive ? "#D6B36A" : undefined }} />
                    {label}
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
